import { StyleSheet } from "react-native";
import { AppTheme } from "../../../theme";

export const bulkEditStyle = (theme: AppTheme) => StyleSheet.create({
    containerView: {
        flex: 1,
        backgroundColor: "#f8f8f8"
    },
    loaderView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "transparent"
    },
    // ── Summary bar (count / unsaved / category / location) ──────────────────
    summaryBar: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 8,
        marginHorizontal: 10,
        marginBottom: 10
    },
    summaryLeft: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 8,
        flexShrink: 1
    },
    summaryRight: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 8
    },
    chip: {
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
        paddingVertical: 6,
        paddingHorizontal: 10,
        borderRadius: 8,
        backgroundColor: theme.coolGray
    },
    unsavedChip: {
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
        paddingVertical: 4,
        paddingHorizontal: 8,
        borderRadius: 8,
        backgroundColor: theme.warmCream,
        borderWidth: 1,
        borderColor: theme.goldenOrange
    },
    // ── Category picker popover ──────────────────────────────────────────────
    categoryPopover: {
        padding: 15,
        gap: 10,
        height: 380
    },
    categoryPopoverHeader: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    categoryItem: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 15,
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderRadius: 8
    },
    categoryItemSelected: {
        backgroundColor: theme.tealPrimary
    },
    emptyCategory: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    // ── List ─────────────────────────────────────────────────────────────────
    listContent: {
        flexGrow: 1,
        paddingHorizontal: 10,
        paddingBottom: 20
    },
    listFooterLoader: {
        height: 50,
        justifyContent: "center",
        alignItems: "center"
    },
    // ── Product card ─────────────────────────────────────────────────────────
    card: {
        marginBottom: 12,
        padding: 12,
        borderRadius: 16,
        backgroundColor: theme.light,
        borderWidth: 1.5,
        borderColor: "transparent",
        elevation: 2,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8
    },
    cardEdited: {
        borderColor: theme.primary
    },
    cardError: {
        borderColor: theme.red
    },
    cardHeader: {
        flexDirection: "row",
        alignItems: "center",
        columnGap: 12
    },
    thumbnail: {
        width: 60,
        height: 60,
        borderRadius: 12,
        backgroundColor: theme.lightBackgroundColor,
        borderWidth: 1,
        borderColor: theme.borderColor
    },
    headerDetails: {
        flex: 1,
        rowGap: 4
    },
    headerBadgeRow: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 6
    },
    infoPill: {
        paddingVertical: 2,
        paddingHorizontal: 8,
        borderRadius: 6,
        backgroundColor: theme.tealPrimary
    },
    lowStockPill: {
        paddingVertical: 2,
        paddingHorizontal: 8,
        borderRadius: 6,
        backgroundColor: theme.lightRed
    },
    headerActions: {
        flexDirection: "row",
        alignItems: "center",
        columnGap: 10
    },
    availability: {
        alignItems: "center"
    },
    expandButton: {
        padding: 6,
        borderRadius: 20,
        backgroundColor: theme.lightBackgroundColor
    },
    cardBody: {
        marginTop: 12,
        paddingTop: 12,
        borderTopWidth: 1,
        borderTopColor: theme.lightBackgroundColor,
        rowGap: 6
    },
    // ── Sections & inputs ────────────────────────────────────────────────────
    sectionTitle: {
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
        paddingHorizontal: 5,
        paddingTop: 4,
        paddingBottom: 10
    },
    sectionFields: {
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start"
    },
    inputContainer: {
        paddingHorizontal: 5,
        marginBottom: 12
    },
    inputInnerContainer: {
        paddingHorizontal: 8,
        borderRadius: 8,
        borderColor: theme.borderColor,
        backgroundColor: theme.light
    },
    inputErrorContainer: {
        borderColor: theme.red
    },
    errorStyle: {
        fontSize: theme.errorFontSize,
        fontFamily: theme.medium,
        color: theme.red,
        paddingTop: 5
    },
    stepperButton: {
        width: 30,
        height: 30,
        borderRadius: 8,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.tealPrimary
    },
    stepperButtonDisabled: {
        backgroundColor: theme.lightBackgroundColor
    },
    // ── Images ───────────────────────────────────────────────────────────────
    imageRow: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 12,
        paddingHorizontal: 5,
        paddingTop: 6,
        paddingBottom: 6
    },
    imageTile: {
        width: 90,
        height: 90,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: theme.borderColor,
        backgroundColor: theme.lightBackgroundColor
    },
    image: {
        width: "100%",
        height: "100%",
        borderRadius: 12
    },
    addImageTile: {
        width: 90,
        height: 90,
        borderRadius: 12,
        borderWidth: 1.5,
        borderStyle: "dashed",
        borderColor: theme.primary,
        backgroundColor: theme.tealPrimary,
        justifyContent: "center",
        alignItems: "center",
        gap: 4
    },
    removeImageButton: {
        position: "absolute",
        right: -8,
        top: -8,
        backgroundColor: theme.light,
        borderRadius: 12
    }
})
